import { HTTPAPIConfig } from './http-api.config';
/**
 * will have all the api config mapping for the project
 */
export const APIConfigMapping: {
  [key: string]: HTTPAPIConfig
} = {
  GET_STATIONS: {
    method: 'get',
    apiKeyName: 'GET_STATIONS',
  },

  GET_STATION_BY_ID: {
    method: 'get',
    apiKeyName: 'GET_STATION_BY_ID',
  },

  ADD_STATION: {
    method: 'post',
    apiKeyName: 'ADD_STATION',
  },

  UPLOAD_SIP_AND_GRADIENT: {
    method: 'multipart',
    apiKeyName: 'UPLOAD_SIP_AND_GRADIENT',
  },
  GET_PROCESSING_STATUS: {
    method: 'post',
    apiKeyName: 'GET_PROCESSING_STATUS',
  },

  GET_TRACKS: {
    method: 'get',
    apiKeyName: 'GET_TRACKS',
  },

  ADD_TRACK: {
    method: 'post',
    apiKeyName: 'ADD_TRACK',
  },

  ADD_STATION_SURVERY: {
    method: 'post',
    apiKeyName: 'ADD_STATION_SURVERY',
  }, 
  FETCH_SURVEY_META_FILES: {
    method: 'post',
    apiKeyName: 'FETCH_SURVEY_META_FILES',
  }, 
  GET_PIM_SIP_FILE: {
    method: 'post',
    apiKeyName: 'GET_PIM_SIP_FILE',
  },
  GET_PIM_GRADIENT_FILE: {
    method: 'post',
    apiKeyName: 'GET_PIM_GRADIENT_FILE',
  },
  POST_EDIT_TABLE_DATA: {
    method: 'multipart',
    apiKeyName: 'POST_EDIT_TABLE_DATA'
  },
  GET_PIM_SIGNALLING_FILE: {
    method: 'post',
    apiKeyName: 'GET_PIM_SIGNALLING_FILE'
  },
  GET_CHILD_ROLE_USERS: {
    method: 'get',
    apiKeyName: 'GET_CHILD_ROLE_USERS',
    urlString:'USERMGMT_API'
  },
  GET_PARENT_ROLE_USERS: {
    method: 'get',
    apiKeyName: 'GET_PARENT_ROLE_USERS',
    urlString:'USERMGMT_API'
  },
  UPDATE_STATION_STATUS: {
    method: 'post',
    apiKeyName: 'UPDATE_STATION_STATUS'
  },
  GET_STATION_VERSIONS: {
    method: 'post',
    apiKeyName: 'GET_STATION_VERSIONS',
  },
  GET_STATION_VERSION_FILE: {
    method: 'post',
    apiKeyName: 'GET_STATION_VERSION_FILE',
  },
  GET_ALL_SELECTED_STATIONS_FILES: {
    method: 'post',
    apiKeyName: 'GET_ALL_SELECTED_STATIONS_FILES',
  },
    ADD_SIGN_TOC: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_TOC',
  },
    ADD_SIGN_TRACK_PROFILE_DATA: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_TRACK_PROFILE_DATA',
  },
    ADD_SIGN_TINS_PDF: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_TINS_PDF',
  },
    ADD_SIGN_RADIO_PDF: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_RADIO_PDF',
  },
    ADD_SIGN_RFID_TAG_DATA: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_RFID_TAG_DATA',
  },

  PLOT_OR_UPDATE_SIP: {
    method: 'post',
    apiKeyName: 'PLOT_OR_UPDATE_SIP'
  },
  GENERATE_COMMENTS: {
    method: 'post',
    apiKeyName: 'GENERATE_COMMENTS'
  },


  // comments
 GET_COMMENTS: {
    method: 'post',
    apiKeyName: 'GET_COMMENTS',
  },
  ADD_COMMENT: {
    method: 'post',
    apiKeyName: 'ADD_COMMENT', 
  },
  UPDATE_COMMENT: {
    method: 'post',
    apiKeyName: 'UPDATE_COMMENT',
  },
  DELETE_COMMENT: {
    method: 'post',
    apiKeyName: 'DELETE_COMMENT',
  },
  ADD_REPLY: {
    method: 'post',
    apiKeyName: 'ADD_REPLY',
  },
  ADD_STATION_DATA: {
    method: 'post',
    apiKeyName: 'ADD_STATION_DATA',
  },
  GET_OEM_RULES: {
    method:'get',
    apiKeyName:'GET_OEM_RULES',
    urlString:'PROJ_API_URL'
  },
  GET_ALL_ZONES: {
    method: 'get',
    apiKeyName: 'GET_ALL_ZONES',
    urlString:'PROJ_API_URL'
  },
  GET_ZONE_RULES_TABLE: {
    method: 'post',
    apiKeyName: 'GET_ZONE_RULES_TABLE',
    urlString:'PROJ_API_URL'
  },
  GET_RULE_TYPES: {
    method: 'get',
    apiKeyName: 'GET_RULE_TYPES',
    urlString:'PROJ_API_URL'
  },
  ADD_RULE_TYPES: {
    method: 'post',
    apiKeyName: 'GET_RULE_TYPES',
    urlString: 'PROJ_API_URL'
  },
  GET_RULE_CATEGORIES: {
    method: 'get',
    apiKeyName: 'GET_RULE_CATEGORIES',
    urlString:'PROJ_API_URL'
  },
  ADD_RULE_CATEGORY: {
    method:'post',
    apiKeyName:'GET_RULE_CATEGORIES',
    urlString:'PROJ_API_URL'
  },
  UPDATE_RULE: {
    method: 'put',
    apiKeyName:'UPDATE_RULE',
    urlString:'PROJ_API_URL'
  },
  ADD_RULE:{
    method:'post',
    apiKeyName:'UPDATE_RULE',
    urlString:'PROJ_API_URL'
  },
  DELETE_RULE: {
    method: 'delete',
    apiKeyName: 'DELETE_RULE',
    urlString: 'PROJ_API_URL'
  },
  GET_SUB_TRACKS: {
    method: 'get',
    apiKeyName: 'GET_SUB_TRACKS',
  },
  ADD_SUB_TRACK: {
    method: 'post',
    apiKeyName: 'ADD_SUB_TRACK',
  },
  SAVE_SUB_TRACK_DATA: {
    method: 'post',
    apiKeyName: 'SAVE_SUB_TRACK_DATA',
  },
  SAVE_SURVEY_DRAFT: {
    method: 'post',
    apiKeyName: 'SAVE_SURVEY_DRAFT',
  },
  PROCESS_SURVEY_FILE_FIRST_PASS: {
    method: 'multipart',
    apiKeyName: 'PROCESS_SURVEY_FILE_FIRST_PASS',
    // urlString: 'MAHESH_API_ULR'
  },
  PROCESS_SURVEY_FILE_SECOND_PASS: {
    method: 'multipart',
    apiKeyName: 'PROCESS_SURVEY_FILE_SECOND_PASS',
  },
    // urlString: 'MAHESH_API_ULR'
  GET_LAYOUT_EDIT_STATUS: {
    method: 'get',
    apiKeyName: 'GET_LAYOUT_EDIT_STATUS',
  },
  UPDATE_LAYOUT_EDIT_STATUS: {
    method: 'post',
    apiKeyName: 'UPDATE_LAYOUT_EDIT_STATUS',
  },
  UPDATE_DRAFT_ACCESS_STATUS: {
    method: 'post',
    apiKeyName: 'UPDATE_DRAFT_ACCESS_STATUS',
  },
  GENERATE_TOC_DOC: {
    method: 'post',
    apiKeyName: 'GENERATE_TOC_DOC',
    options: {
      responseType: 'blob'
    }
  },
  GENERATE_TPT_DOC: {
    method: 'post',
    apiKeyName: 'GENERATE_TPT_DOC',
    options: {
      responseType: 'blob'
    }
  },
  GET_ZONE_LIST: {
    method: 'post',
    apiKeyName: 'GET_ZONE_LIST'
  },
  GET_VENDOR_LIST: {
    method: 'post',
    apiKeyName: 'GET_VENDOR_LIST'
  },
  GET_HEADER_TYPES: {
    method: 'post',
    apiKeyName: 'GET_HEADER_TYPES'
  },
  CREATE_OR_UPDATE_TOC_HEADER: {
    method: 'post',
    apiKeyName: 'CREATE_OR_UPDATE_TOC_HEADER'
  },
  GET_TOC_HEADER_DATA: {
    method: 'post',
    apiKeyName: 'GET_TOC_HEADER_DATA'
  },
  UPDATE_SIGNALLING_TOC_DATA: {
    method: 'post',
    apiKeyName: 'UPDATE_SIGNALLING_TOC_DATA'
  },
  LOCK_STATION_LAYOUT: {
    method: 'post',
    apiKeyName: 'LOCK_STATION_LAYOUT',
  },
  UNLOCK_STATION_LAYOUT: {
    method: 'post',
    apiKeyName: 'UNLOCK_STATION_LAYOUT',
  },
  REFRESH_STATION_LAYOUT_LOCK: {
    method: 'post',
    apiKeyName: 'REFRESH_STATION_LAYOUT_LOCK',
  },
  GET_DB_FILE_DOWNLOAD: {
    method: 'get',
    apiKeyName: 'GET_DB_FILE_DOWNLOAD'
  },
  GET_TOC_CHEAT_SHEET_PDF: {
    method: 'get',
    apiKeyName: 'GET_TOC_CHEAT_SHEET_PDF'
  },
  COPY_SURVEY_DRAFT: {
    method: 'post',
    apiKeyName: 'COPY_SURVEY_DRAFT',
  },
  EXTRACT_PSR_EXCEL: {
    method: 'multipart',
    apiKeyName: 'EXTRACT_PSR_EXCEL'
  },
  ON_GRADIENT_FILE_UPLOAD: {
    method: 'multipart',
    apiKeyName: 'ON_GRADIENT_FILE_UPLOAD'
  },
  GET_ALL_TAG_DATA: {
    method: 'get',
    apiKeyName: 'GET_ALL_TAG_DATA'
  },
  GET_STATION_IP_ADDRESS: {
    method: 'get',
    apiKeyName: 'GET_STATION_IP_ADDRESS'
  },
  ZONE_VENDOR_TYPE_DELETE: {
    method: 'delete',
    apiKeyName: 'ZONE_VENDOR_TYPE_DELETE',
    postData: {}
  },
  GET_ZONES: {
    method: 'get',
    apiKeyName: 'GET_ZONES',
  },
  GET_DIVISIONS: {
    method: 'post',
    apiKeyName: 'GET_DIVISIONS',
  },
  GET_STATIONS_LIST: {
    method: 'post',
    apiKeyName: 'GET_STATIONS_LIST',
  },

  DELETE_STATION_MASTER_DATA:{
    method: 'post',
    apiKeyName: 'DELETE_STATION_MASTER_DATA'
  },
  GET_TRACK_WITH_ADJUSTMENT: {
    method: 'post',
    apiKeyName: 'GET_TRACK_WITH_ADJUSTMENT',
    postData: {}
  },
  SLF_CTF_FILE_UPLOAD: {
    method: 'multipart',
    apiKeyName: 'SLF_CTF_FILE_UPLOAD'
  },
  GET_SLF_CTF_FILES_DATA: {
    method: 'get',
    apiKeyName: 'GET_SLF_CTF_FILES_DATA'
  },
  GAP_INTERVAL_ANALYZER: {
    method: 'post',
    apiKeyName: 'GAP_INTERVAL_ANALYZER'
  },
  GET_LAYOUT_VERSIONS: {
    method: 'post',
    apiKeyName: 'GET_LAYOUT_VERSIONS'
  },
  GET_LAYOUT_VERSION_DATA: {
    method: 'post',
    apiKeyName: 'GET_LAYOUT_VERSION_DATA'
  },
  GET_LAYOUT_SUBMISSION_STATUS: {
    method: 'get',
    apiKeyName: 'GET_LAYOUT_SUBMISSION_STATUS'
  },

  APPLY_ANTI_COLLISION_ON_RED_AND_GREEN_DATA: {
    method: 'multipart',
    apiKeyName: 'APPLY_ANTI_COLLISION_ON_RED_AND_GREEN_DATA'
  },

  // Rail V1 APIs
  GET_ZONES_V1: {
    method: 'get',
    apiKeyName: 'GET_ZONES_V1',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_DIVISIONS_V1: {
    method: 'get',
    apiKeyName: 'GET_DIVISIONS_V1',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_SECTIONS_V1: {
    method: 'get',
    apiKeyName: 'GET_SECTIONS_V1',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_STATIONS_RAW_V1: {
    method: 'get',
    apiKeyName: 'GET_STATIONS_RAW_V1',
    urlString: 'PROJ_API_V1_URL'
  },
  ADD_STATION_V1: {
    method: 'post',
    apiKeyName: 'ADD_STATION_V1',
    urlString: 'PROJ_API_V1_URL'
  },
  UPDATE_STATION_V1: {
    method: 'patch',
    apiKeyName: 'UPDATE_STATION_V1',
    urlString: 'PROJ_API_V1_URL'
  },
  DELETE_STATION_V1: {
    method: 'delete',
    apiKeyName: 'DELETE_STATION_V1',
    urlString: 'PROJ_API_V1_URL'
  },

  DOCUMENT_SUBMISSION_INITIATE: {
    method: 'post',
    apiKeyName: 'DOCUMENT_SUBMISSION_INITIATE',
    urlString: 'PROJ_API_V1_URL'
  },
  CHECK_REFERENCE_AVAILABILITY: {
    method: 'get',
    apiKeyName: 'CHECK_REFERENCE_AVAILABILITY',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_DOCUMENT_REFERENCES: {
    method: 'get',
    apiKeyName: 'GET_DOCUMENT_REFERENCES',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_SUBMISSIONS: {
    method: 'get',
    apiKeyName: 'GET_SUBMISSIONS',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_SUBMISSION_STATUS: {
    method: 'get',
    apiKeyName: 'GET_SUBMISSION_STATUS',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_SUBMISSION_VERSIONS: {
    method: 'get',
    apiKeyName: 'GET_SUBMISSION_VERSIONS',
    urlString: 'PROJ_API_V1_URL'
  },
  INITIATE_VERSION_UPLOAD: {
    method: 'post',
    apiKeyName: 'INITIATE_VERSION_UPLOAD',
    urlString: 'PROJ_API_V1_URL'
  },
  CONFIRM_VERSION_UPLOAD: {
    method: 'post',
    apiKeyName: 'CONFIRM_VERSION_UPLOAD',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_STATION_DOCUMENT_VERSIONS: {
    method: 'get',
    apiKeyName: 'GET_STATION_DOCUMENT_VERSIONS',
    urlString: 'PROJ_API_V1_URL'
  },
  CONFIRM_DOCUMENT_UPLOAD: {
    method: 'post',
    apiKeyName: 'CONFIRM_DOCUMENT_UPLOAD',
    urlString: 'PROJ_API_V1_URL'
  },
  CONFIRM_DOCUMENT_SUBMISSION: {
    method: 'post',
    apiKeyName: 'CONFIRM_DOCUMENT_SUBMISSION',
    urlString: 'PROJ_API_V1_URL'
  },
  DELETE_DOCUMENT_VERSION: {
    method: 'delete',
    apiKeyName: 'DELETE_DOCUMENT_VERSION',
    urlString: 'PROJ_API_V1_URL'
  },
  DELETE_DOCUMENT_SUBMISSION: {
    method: 'delete',
    apiKeyName: 'DELETE_DOCUMENT_SUBMISSION',
    urlString: 'PROJ_API_V1_URL'
  },
  DOCUMENT_STATUS_UPDATE: {
    method: 'post',
    apiKeyName: 'DOCUMENT_STATUS_UPDATE',
    urlString: 'PROJ_API_V1_URL'
  },
  TRIGGER_EXTRACTION: {
    method: 'post',
    apiKeyName: 'TRIGGER_EXTRACTION',
    urlString: 'PROJ_API_V1_URL'
  },

  INITIATE_DIGITALISE: {
    method: 'post',
    apiKeyName: 'INITIATE_DIGITALISE',
    urlString: 'PROJ_API_V1_URL'
  },
  CONFIRM_DIGITALISE: {
    method: 'post',
    apiKeyName: 'CONFIRM_DIGITALISE',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_SUBMISSION_ASSETS: {
    method: 'get',
    apiKeyName: 'GET_SUBMISSION_ASSETS',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_VERSION_ASSETS_SUMMARY: {
    method: 'get',
    apiKeyName: 'GET_VERSION_ASSETS_SUMMARY',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_VERSION_ASSET_TYPE_DETAILS: {
    method: 'get',
    apiKeyName: 'GET_VERSION_ASSET_TYPE_DETAILS',
    urlString: 'PROJ_API_V1_URL'
  },
  PATCH_VERSION_ASSET_TYPE_BATCH: {
    method: 'patch',
    apiKeyName: 'PATCH_VERSION_ASSET_TYPE_BATCH',
    urlString: 'PROJ_API_V1_URL'
  },
  CONFIRM_ASSET_DXF_UPLOAD: {
    method: 'post',
    apiKeyName: 'CONFIRM_ASSET_DXF_UPLOAD',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_TABLE_TYPES: {
    method: 'get',
    apiKeyName: 'GET_TABLE_TYPES',
    urlString: 'PROJ_API_V1_URL'
  },
  MOVE_TABLE: {
    method: 'post',
    apiKeyName: 'MOVE_TABLE',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_STRUCTURE_TYPES: {
    method: 'get',
    apiKeyName: 'GET_STRUCTURE_TYPES',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_ASSET_ATTRIBUTE_TYPES: {
    method: 'get',
    apiKeyName: 'GET_ASSET_ATTRIBUTE_TYPES',
    urlString: 'PROJ_API_V1_URL'
  },

  GENERATE_SIP: {
    method: 'post',
    apiKeyName: 'GENERATE_SIP',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_SIP_STATUS: {
    method: 'get',
    apiKeyName: 'GET_SIP_STATUS',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_SIP_UPLOAD_PRESIGNED_URL: {
    method: 'post',
    apiKeyName: 'GET_SIP_UPLOAD_PRESIGNED_URL',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_SIP_UPLOAD_JSON_PRESIGNED_URL: {
    method: 'post',
    apiKeyName: 'GET_SIP_UPLOAD_JSON_PRESIGNED_URL',
    urlString: 'PROJ_API_V1_URL'
  },
  CONFIRM_SIP_JSON_UPLOAD: {
    method: 'patch',
    apiKeyName: 'CONFIRM_SIP_JSON_UPLOAD',
    urlString: 'PROJ_API_V1_URL'
  },
  CONFIRM_SIP_DXF_UPLOAD: {
    method: 'patch',
    apiKeyName: 'CONFIRM_SIP_DXF_UPLOAD',
    urlString: 'PROJ_API_V1_URL'
  },
  FETCH_SIP_DATA: {
    method: 'get',
    apiKeyName: 'FETCH_SIP_DATA',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_SIP_ARTIFACTS: {
    method: 'get',
    apiKeyName: 'GET_SIP_ARTIFACTS',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_STATION_CONFIGURATION: {
    method: 'get',
    apiKeyName: 'GET_STATION_CONFIGURATION',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_STATION_CONFIGURATION_SIP_GEN: {
    method: 'get',
    apiKeyName: 'GET_STATION_CONFIGURATION_SIP_GEN',
    urlString: 'PROJ_API_V1_URL'
  },

  TRIGGER_SOD_VALIDATION: {
    method: 'post',
    apiKeyName: 'TRIGGER_SOD_VALIDATION',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_LATEST_SOD_VALIDATION: {
    method: 'get',
    apiKeyName: 'GET_LATEST_SOD_VALIDATION',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_RULE_VALIDATION_RESULTS: {
    method: 'get',
    apiKeyName: 'GET_RULE_VALIDATION_RESULTS',
    urlString: 'PROJ_API_V1_URL'
  },

  //YARD REMODELING
  SAVE_YARD_REMODELING: {
    method: 'post',
    apiKeyName: 'SAVE_YARD_REMODELING',
    // Without this, processConfig defaults urlString to 'PROJ_API' (= BASE_URL + '/'),
    // producing BASE_URL//v1/esp/... — a double slash, and missing the /api prefix
    // every other endpoint has. PROJ_API_URL (= BASE_URL + '/api') keeps the
    // '/v1/...' already in the path and lands on BASE_URL/api/v1/esp/yard-remodeling/:espId.
    urlString: 'PROJ_API_URL'
  },

  FILTER_YARD_REMODELING_COMBINATIONS: {
    method: 'post',
    apiKeyName: 'FILTER_YARD_REMODELING_COMBINATIONS',
    urlString: 'PROJ_API_URL'
  },

  GET_YARD_REMODELING_REQUEST: {
    method: 'get',
    apiKeyName: 'GET_YARD_REMODELING_REQUEST',
    urlString: 'PROJ_API_URL'
  },

  GET_STATION_OPTIONS: {
    method: 'get',
    apiKeyName: 'GET_STATION_OPTIONS',
    urlString: 'PROJ_API_V1_URL'
  },
  GET_DOCUMENT_TYPE_OPTIONS: {
    method: 'get',
    apiKeyName: 'GET_DOCUMENT_TYPE_OPTIONS',
    urlString: 'PROJ_API_V1_URL'
  }
}



